import Layout from "features/streamLayout/layout";

const fullscreenLayout: Layout = {
  name: "Fullscreen",
  image: "layouts/fullscreen.png",
  slots: 1,
};
export default fullscreenLayout;